const Header = () => {
  return (
    <header>
      {/* <h1>Pearson Active Learn Download</h1> */}
    </header>
  )
}

export default Header
